import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import { Link } from 'react-router-dom';

import MainMenu from './Pages/MainMenu';

const Header = (props) => {
    const [showMenu, setShowMenu] = useState(false);
    const [scrolled, setScrolled] = useState(0);
    let slug = props.match.path;

    const handleKeyPress = (e) => {
        if (e.keyCode === 27 && showMenu === true) {
            setShowMenu(false);
        }
    };

    const updateScrollPosition = () => {
        let scrollpos = 0;
        scrollpos = window.scrollY;
        setScrolled(scrollpos);
    };

    const logoOnScroll = () => {
        if (props.isWork && props.slider) {
            if (props.slider.acf.slider) {
                if (scrolled < 500) {
                    return 'clr-white';
                } else {
                    return 'clr-black';
                }
            }
        }
    };

    const removeTagline = () => {
        if (scrolled > 100) {
            return 'hide-tagline';
        } else {
            return '';
        }
    };

    const handleClick = () => {
        showMenu ? setShowMenu(false) : setShowMenu(true);
    };

    useEffect(() => {
        updateScrollPosition();
        window.addEventListener('scroll', updateScrollPosition);
        window.addEventListener('keydown', handleKeyPress);

        return () => {
            window.removeEventListener('scroll', updateScrollPosition);
            window.removeEventListener('keydown', handleKeyPress);
        };
    });

    return (
        <header id="header">
            <div className="alignLeft">
                <div
                    className={`logo ${logoOnScroll()}
                    ${slug === '/work/:slug' && 'hide-logo'}`}>
                    <Link
                        to="/"
                        className={slug === '/' ? 'prevent-default' : null}>
                        <span className="brand-name">
                            Friends
                            <br /> for <br />
                        </span>
                        <div className="nameslider">
                            <span className="title">
                                Brands <br />
                            </span>
                        </div>
                    </Link>
                </div>
                <div
                    className={`tagline ${logoOnScroll()} ${removeTagline()} ${
                        slug === '/work/:slug' && 'hide-logo'
                    }`}>
                    <span>Creative Agency</span>
                </div>
                {slug === '/work/:slug' && (
                    <Link className="cta-btn cta-btn-back white" to="/work">
                        <span>Back</span>
                    </Link>
                )}
            </div>
            <div className="alignRight">
                <div
                    onClick={handleClick}
                    className={`hamburger hamburger--spin ${logoOnScroll()} ${
                        showMenu ? 'active' : 'hidden'
                    }`}>
                    <div className="hamburger-box">
                        <div className="hamburger-inner" />
                    </div>
                </div>
                <MainMenu showMenu={showMenu} />
                <div className={`cta-contact hidden-xs ${logoOnScroll()}`}>
                    <Link to="/contact/">
                        <i className="icon icon-envelop" />
                    </Link>
                </div>
            </div>
        </header>
    );
};

export default withRouter(React.memo(Header));



// WEBPACK FOOTER //
// ./src/components/Header.jsx